import React, { FC } from 'react';
import { Card } from '@mui/material';
import { StyledCardHeader } from 'molecules/Card/Card.styles';
import type { BlockProps } from './types';

const BlockWithActions: FC<BlockProps> = ({
  avatar,
  title,
  children,
  action,
  ...props
}) => (
  <Card {...props}>
    <StyledCardHeader
      component="div"
      avatar={avatar}
      title={title}
      action={action}
    />
    {children}
  </Card>
);

export default BlockWithActions;
